module.exports = __webpack_public_path__ + "static/media/w_25.36ac5aac.png";